import React, { useState, useEffect, ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';

interface Props {
  isVisible: boolean;
  onConfirm?: () => void;
  onClose?: () => void;
}

const ResetDialog: React.FC<Props> = (props: Props) => {
  const handleConfirm = () => {
    props.onConfirm?.();
    props.onClose?.();
  };

  return (
    <Dialog open={props.isVisible} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="text-xl text-neutral-600 !font-bold">Återställ RegU-begäran</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div>
            <p>Detta återställer RegU-begäran till status Ej hanterad.</p>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="!px-[20px] !py-[24px] !justify-between">
        <Button className="w-52 h-12" variant="outlined" color="error" onClick={props.onClose}>
          Avbryt
        </Button>

        <Button
          className="w-52 h-13"
          variant="contained"
          color="primary"
          endIcon={<RestartAltOutlinedIcon />}
          sx={{
            '&.Mui-disabled': {
              backgroundColor: '#43967680',
              color: 'white',
              opacity: 1,
            },
          }}
          onClick={handleConfirm}
        >
          Återställ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetDialog;
